import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const ForumTopicBasicInfoComponent = ({
    selectedForumTopic, handleInnerFormChange, forums, libraryData
}: any) => {
    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                        <InputContainer
                            label="Forum"
                            labelField="Name"
                            list={forums}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ForumId'
                                )
                            }}
                            optionName='Choose Forum '
                            type="select"
                            value={selectedForumTopic?.ForumId}
                            valueField="Id"
                        />



                        <InputContainer
                            label="TopicType"
                            labelField="Text"
                            list={libraryData.result.CommunityStatus}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'TopicTypeId'
                                )
                            }}
                            optionName='Choose Topic Type'
                            type="select"
                            value={selectedForumTopic?.TopicTypeId}
                            valueField="Value"
                        />

                        <div className="col-span-full">
                            <InputContainer
                                label="Subject"
                                labelField="Subject"
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Subject'
                                    );
                                }}
                                type="text"
                                value={selectedForumTopic?.Subject}
                            />
                        </div>


                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}

export default ForumTopicBasicInfoComponent;
